<template>
    <div>
        <v-container grid-list-xs>
            <template>
                <v-toolbar flat color="white">
                    
                    <v-toolbar-title>
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                        ></v-text-field>
                    </v-toolbar-title>

                    <v-spacer></v-spacer>                  
                </v-toolbar>
            </template>
        </v-container>
        
        <v-container grid-list-xs>
            <v-data-table
                class="table"
                :headers="headers"
                :items="users"
                :search="search"
                :sort-by="[{ key: 'code', order: 'code' }]"
                :rows-per-page-items="[10, 25]">
                <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.p_code }}</td>
                <td class="text-xs-left">{{ props.item.name }}</td>                
                <!-- <td class="text-xs-left">{{ props.item.expiration_date }}</td> -->
                <td class="text-xs-left">{{ props.item.qty }}</td>                                     
                <td class="text-xs-center">
                    <v-icon class="mr-2" @click="view_details( props.item.p_code )">visibility</v-icon>
                    <v-icon class="mr-2" @click="view_transaction( props.item.p_code )">view_list</v-icon>
                    
                </td>
                </template>

            </v-data-table>

            
        </v-container>


    </div>
    
</template>
  
<script>
import axios from "axios"

  export default {    
        
    data() {
        return {
                /** กำหนด headers ให้ตรง */
                headers:[ 
                { text: 'Code', value: 'p_code'  },
                { text: 'Name', value: 'name' },
                // { text: 'Exp. Date', value: 'expiration_date' },
                { text: 'qty', value: 'qty' },
                { text: 'Actions', value: 'actions', align: 'center', sortable: false },                
                ],
                table_details:[],
                users: [],
                search: '',
                dialog : false,
                branch : '',
                date: new Date().toISOString().substr(0, 10),
                url : "https://ws.plantifulbkk.shop/images/" ,
            }
        },
        created () {

            this.read_data()
            this.branch = this.$store.getters.get_branch
        },

        methods :{
            read_data() {
                const vm = this;
                vm.axios.get('https://ws.plantifulbkk.shop/get_inventory.php').then(response => {
                var result = JSON.parse(JSON.stringify(response.data))
                vm.users = result
                console.log(vm.users)
                });
            },
                  
            view_details(  itemcode ){                
                this.$store.dispatch('set_docno_ac', itemcode )
                this.$router.push('/view_inventory')
            },

            view_transaction( itemcode ){
                this.$store.dispatch('set_docno_ac', itemcode )
                this.$router.push('/view_transaction')
                
            },

        },    
  
  }
</script>
  
<style scoped>
.v-text-field{
      width: 200px;
}
</style>


// WEBPACK FOOTER //
// src/pages/inventory.vue